import { AnalyticsActions, OccAnalyticsService } from '@analytics/data-access';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { YandexMetrikaService } from '../services';

@Injectable()
export class AnalyticsEffects {
  init$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        take(1),
        map(() => {
          this.yandexMetrikaService.initFirstVisitLog();
        }),
      ),
    { dispatch: false },
  );

  firstVisitLog$: Observable<void> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AnalyticsActions.FIRST_VISIT_LOG),
        switchMap(({ payload }) => this.occAnalyticsService.firstVisitLog(payload)),
        map(() => undefined),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private occAnalyticsService: OccAnalyticsService,
    private yandexMetrikaService: YandexMetrikaService,
  ) {}
}
